import React, { useEffect, useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { FirebaseContext } from "../lib/firebase";
import "../main.css";

const Login = () => {
  const { auth, api } = useContext(FirebaseContext);
  const { signInWithEmailAndPasswordFunction } = api;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [teamPassword, setTeamPassword] = useState("");
  const [user, loading] = useAuthState(auth);
  const navigate = useNavigate();
  useEffect(() => {
    if (loading) {
      // maybe trigger a loading screen
      return;
    }
    if (user) navigate("/dashboard");
  }, [user, loading, navigate]);
  return (
    <div className='login'>
      <div className='login__container'>
        <input
          type='text'
          className='login__textBox team-password'
          value={teamPassword}
          onChange={(e) => setTeamPassword(e.target.value)}
          placeholder='Team Password'
        />
        <input
          type='email'
          className='login__textBox'
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder='E-mail Address'
        />
        <input
          type='password'
          className='login__textBox'
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder='Password'
        />
        <button
          className='login__btn'
          onClick={() =>
            signInWithEmailAndPasswordFunction(email, password, teamPassword)
          }
        >
          Login
        </button>
        {/* <button
          className='login__btn login__google'
          onClick={() => signInWithGoogle(teamPassword)}
        >
          Login with Google
        </button> */}
        <div className='text-white'>
          <Link to='/reset'>Forgot Password</Link>
        </div>
      </div>
    </div>
  );
};
export default Login;
